import React from 'react'
import { Theme, Button } from '@material-ui/core'

interface SubmitButtonAreaProps {
    theme: Theme
    selectedValueIds: number[]
    onSubmit: () => void
}

export const SubmitButtonArea: React.FC<SubmitButtonAreaProps> = ({
    theme,
    selectedValueIds,
    onSubmit,
}) => {
    return (
        <div
            style={{
                padding: '16px',
                borderTop: `1px solid ${theme.palette.divider}`,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: theme.palette.background.paper,
                position: 'sticky',
                bottom: 0,
                zIndex: 1,
            }}
        >
            <div>
                {selectedValueIds.length} item
                {selectedValueIds.length !== 1 ? 's' : ''} selected
            </div>
            <Button
                variant="contained"
                color="primary"
                onClick={onSubmit}
                disabled={selectedValueIds.length === 0}
            >
                Accept Selected
            </Button>
        </div>
    )
}
